<template>
  <div
    v-if="display"
    class="modal-backdrop"
    tabindex="0"
    @click.self="cancel()"
    @click.stop
    @keyup.esc="cancel()"
  >
    <div class="cart-modal">
      <div class="cart-modal__body cart-modal__body--spacious cart__confimation">
        <p
          v-if="failed"
          class="cart__confimation__heading"
        >
          Tarjouksen WC-{{ offerId }} poisto epäonnistui. Yritä uudelleen?
        </p>
        <p
          v-else-if="confirmed"
          class="cart__confimation__heading"
        >
          Tarjous WC-{{ offerId }} on poistettu.
        </p>
        <p
          v-else
          class="cart__confimation__heading"
        >
          Haluatko varmasti poistaa tarjouksen WC-{{ offerId }}?
        </p>

        <div
          v-if="!confirmed"
          class="cart__confimation__actions"
        >
          <button
            class="btn btn--secondary btn--secondary-med btn--inline"
            @click.prevent="cancel()"
            @click.stop
          >
            Peruuta
          </button>
          <button
            class="btn btn--med btn--inline"
            @click.prevent="confirm()"
            @click.stop
          >
            Poista
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        display: Boolean,
        offerId: {
            type: Number,
            default: 0,
        },
        nonce: {
            type: String,
            default: '',
        },
    },

    data : function () {
        return {
            confirmed: false,
            failed: false,
        }
    },

    methods: {

        confirm() {
            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
                params: {
                    'offer_id': this.offerId,
                },
            }

            axios.delete('/wp-json/modeo/v2/offer', config)
            .then(response => {
                if (response.data == true) {
                    this.confirmed = true;
                    this.failed = false;

                    setTimeout(function() {

                        if ( window.location.href.indexOf('ostoskori') !== -1) {
                            window.location = '/tarjoukset/';
                        }

                        window.location.reload();
                    }, 500);
                } else {
                    this.failed = true;
                }
            })
            .catch(e => {
                console.log('Error: ', e);
            });
        },

        cancel() {
            this.$emit("cancel");
        },

    },
}
</script>
